import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	routes: [{
			path: '/',
			redirect: '/login'
		},{
			path: '/home',
			component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
			meta: {
				title: '系统首页'
			},
			children: [
				{
					path: '/dashboard',
					component: () => import('../components/page/Dashboard.vue'),
					meta: {
						title: '系统首页',
						affix: true
					}
				},
				{
					path: '/menu',
					component: () => import( /* webpackChunkName: "dashboard" */ '../components/page/system/SysMenu.vue'),
					meta: {
						title: '菜单管理'
					}
				},
				{
					path: '/role',
					component: () => import( /* webpackChunkName: "dashboard" */ '../components/page/system/SysRole.vue'),
					meta: {
						title: '角色管理'
					}
				},
				{
					path: '/user',
					component: () => import( /* webpackChunkName: "dashboard" */ '../components/page/system/SysUser'),
					meta: {
						title: '用户管理'
					}
				},
                {
                    path: '/namespace',
                    component: () => import( /* webpackChunkName: "dashboard" */ '../components/page/system/Namespace'),
                    meta: {
                        title: '系统命名空间管理'
                    }
                }
			]
		},
		{
			path: '/main',
			component: () => import( /* webpackChunkName: "login" */ '../components/page/Home'),
			meta: {
				title: '请选择系统'
			}
		},
		{
			path: '/casLogin',
			component: () => import( /* webpackChunkName: "login" */ '../components/page/casLogin'),
			meta: {
				title: '后台登录'
			}
		},
		{
			path: '/login',
			component: () => import( /* webpackChunkName: "login" */ '../components/page/Login'),
			meta: {
				title: '登录校验'
			}
		},
		{
			path: '/loginform',
			component: () => import( /* webpackChunkName: "login" */ '../components/page/LoginForm'),
			meta: {
				title: '登录'
			}
		},{
			path: '/logout',
			component: () => import( /* webpackChunkName: "login" */ '../components/page/Logout'),
			meta: {
				title: '注销'
			}
		},
		{
			path: '*',
			redirect: '/404'
		},
		{
			path: '/setPwd',
			component: () => import( /* webpackChunkName: "dashboard" */ '../components/page/EditPassword'),
			meta: {
				title: '修改密码'
			}
		}
	]
});
